var _defs, _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIkonerLrestederLarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#333;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Ikoner") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M60.66,40.46a1,1,0,0,1-1-1V5.17a1,1,0,0,1,.52-.86,1,1,0,0,1,1,.08c.26.19,6.45,4.57,13.54.93,6.91-3.53,11.7,0,11.91.19a1,1,0,0,1,.37.76V21.48a1,1,0,0,1-.53.86,1,1,0,0,1-1-.09,8.86,8.86,0,0,0-5-1.28,12.54,12.54,0,0,0-4.8,1.37c-2.59,1.13-5.54,2.42-9.65.94a1,1,0,0,1,.65-1.81c3.39,1.21,5.74.19,8.24-.89A14.07,14.07,0,0,1,80.45,19a12.09,12.09,0,0,1,4.68.85V6.79C84,6.14,80.48,4.56,75.65,7a15.13,15.13,0,0,1-14-.18V39.5A1,1,0,0,1,60.66,40.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M117.14,115.88H3.55a1,1,0,0,1-1-1v-6.65a1,1,0,0,1,1-1H4.64V70.69H3.55a1,1,0,0,1-1-1v-5.6a1,1,0,0,1,1-1H29.24V45.49H28.15a1,1,0,0,1-1-1V39.79a1,1,0,0,1,1-1H92.4a1,1,0,0,1,1,1V44.6a1,1,0,0,1-1,1H90.85v17.6h26.4a1,1,0,0,1,1,1v5.66a1,1,0,0,1-1,1h-1.53l.16,36.63h1.26a1,1,0,0,1,1,1v6.56A1,1,0,0,1,117.14,115.88ZM4.52,114H116.18v-4.64h-1.26a1,1,0,0,1-1-1l-.17-38.55a1,1,0,0,1,1-1h1.53V65.1H89.89a1,1,0,0,1-1-1V44.6a1,1,0,0,1,1-1h1.55V40.75H29.12v2.81H30.2a1,1,0,0,1,1,1v19.6a1,1,0,0,1-1,1H4.52v3.67H5.6a1,1,0,0,1,1,1v38.53a1,1,0,0,1-1,1H4.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M60.41,68.66a10.4,10.4,0,1,1,10.4-10.4A10.41,10.41,0,0,1,60.41,68.66Zm0-18.88a8.48,8.48,0,1,0,8.47,8.48A8.49,8.49,0,0,0,60.41,49.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M60.49,60.36a.73.73,0,0,1-.73-.72V53.09a.73.73,0,0,1,1.45,0v6.55A.72.72,0,0,1,60.49,60.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M60.46,60.39H55.9a.73.73,0,0,1-.73-.72.73.73,0,0,1,.73-.73h4.56a.73.73,0,0,1,.72.73A.72.72,0,0,1,60.46,60.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M76.42,109.14h-32a1,1,0,0,1,0-1.93h32a1,1,0,0,1,0,1.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M71.28,108.42a1,1,0,0,1-1-1V83.93H50.49v23.53a1,1,0,0,1-1.92,0V83a1,1,0,0,1,1-1H71.28a1,1,0,0,1,1,1v24.5A1,1,0,0,1,71.28,108.42Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIkonerLrestederLarge);
export default __webpack_public_path__ + "static/media/Ikoner_Læresteder_large.e57396b27c4b6739e39c8151867d5fa7.svg";
export { ForwardRef as ReactComponent };